import { API_BASE_URL, apiFetch } from "../../services/api";

/**
 * Company OIDC SSO is always offered on login when the backend is configured.
 * Start is a full browser redirect (authorization code + PKCE).
 */
export function startCompanyOidcSso(opts = {}) {
  const params = new URLSearchParams();
  if (opts.domain) params.set("domain", opts.domain);
  if (opts.organizationId) params.set("organization_id", opts.organizationId);
  const qs = params.toString();
  const url = `${API_BASE_URL}/api/auth/oidc/start${qs ? `?${qs}` : ""}`;
  window.location.assign(url);
}

export function readOidcReturnFromUrl() {
  if (typeof window === "undefined") return null;
  try {
    const p = new URLSearchParams(window.location.search);
    const code = String(p.get("oidc_code") || "").trim();
    const legacyToken = String(p.get("oidc_token") || "").trim();
    const error = String(p.get("oidc_error") || "").trim();
    if (code) return { type: "oidc-code", code };
    // Backward compat during rolling deploys
    if (legacyToken) return { type: "oidc-success", token: legacyToken };
    if (error) return { type: "oidc-error", message: error };
    return null;
  } catch {
    return null;
  }
}

export function cleanOidcUrlParams() {
  if (typeof window === "undefined") return;
  try {
    const cleaned = new URL(window.location.href);
    ["oidc_token", "oidc_code", "oidc_error"].forEach((k) =>
      cleaned.searchParams.delete(k)
    );
    window.history.replaceState(
      {},
      document.title,
      `${cleaned.pathname}${cleaned.search}${cleaned.hash}`
    );
  } catch {
    /* ignore */
  }
}

export async function exchangeOidcCode(code) {
  const res = await apiFetch("/api/auth/oidc/exchange", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });
  if (!res.ok) {
    throw new Error("oidc exchange failed");
  }
  return res.json();
}
